import React from 'react';
import moment from "moment";
import {Row} from "react-bootstrap";

const CustomerViewInvoiceHeader = ({invoice, clientLogo, isMobile}) => {

    const logo = () => {
        return <div className="logo">
            <img src={clientLogo && clientLogo} alt="Client Logo"/>
        </div>
    }

    const companyDetails = () => {
        return <div className="company-details text-success">
            <div>
                <strong>{invoice.client_name}</strong>
            </div>
            <div><strong>{invoice.client_address}</strong></div>
            <div><strong>{invoice.client_city}, {invoice.client_state} {invoice.client_zip}</strong></div>
            <div><strong>{invoice.client_phone}</strong></div>
            <div><strong>{invoice.client_email}</strong></div>
        </div>
    }

    const arborist = () => {
        return <div className="arborist text-success">
            <strong>Arborist:</strong>
            <div>{invoice.sales_arborist_name}</div>
            <div>{invoice.arborist_phone}</div>
            <div>{invoice.arborist_email}</div>
        </div>
    }

    const invoiceDetails = () => {
        return <div className="invoice-details text-success">
            <Row>
                <strong>
                    <div>Proposal No.</div>
                </strong>
                <div>{invoice.proposal_no}</div>
            </Row>
            <Row>
                <strong>
                    <div>Date:</div>
                </strong>
                <div>{moment(invoice.proposal_date).format('YYYY/MM/DD')}</div>
            </Row>
            <Row>
                <strong>
                    <div>Invoice No.</div>
                </strong>
                <div>{invoice.number}</div>
            </Row>
            <Row>
                <strong>
                    <div>Date:</div>
                </strong>
                <div>{moment(invoice.invoiced_at).format('YYYY/MM/DD')}</div>
            </Row>
        </div>
    }

    const customerInfo = () => {
        return <div className="customer text-danger">
            <Row>
                <strong>
                    <div>Customer:</div>
                </strong>
                <span>{invoice.customer_full_name}</span>
            </Row>
            <Row>
                <strong>
                    <div>Site:</div>
                </strong>
                <span>{invoice.site_name}</span>
            </Row>
        </div>
    }

    const customerSite = () => {
        return <div className="customer-site text-danger">
            <Row>
                <strong>
                    <div>Site Address</div>
                </strong>
                <span>{invoice.site_full_address}</span>
            </Row>
            <Row>
                <strong>
                    <div>Purchase Order</div>
                </strong>
                <span>{invoice.purchase_order}</span>
            </Row>
        </div>
    }

    return (
        <div className="customer-view-header">
            {!isMobile ? (
                <>
                    {logo()}
                    {companyDetails()}
                    {arborist()}
                    {invoiceDetails()}
                    {customerInfo()}
                    {customerSite()}
                </>
            ) : (
                <>
                    {logo()}
                    {companyDetails()}
                    {arborist()}
                    {invoiceDetails()}
                    <div className="text-danger">
                        <Row>
                            <strong>
                                <div>Customer:</div>
                            </strong>
                            <span>{invoice.customer_full_name}</span>
                        </Row>
                        <Row>
                            <strong>
                                <div>Purchase Order</div>
                            </strong>
                            <span>{invoice.purchase_order}</span>
                        </Row>
                        <Row>
                            <strong>
                                <div>Site:</div>
                            </strong>
                            <span>{invoice.site_name}</span>
                        </Row>

                        <Row className="site-address row">
                            <strong>
                                <div>Site Address</div>
                            </strong>
                            <span>{invoice.site_full_address}</span>
                        </Row>
                    </div>
                </>
            )}
        </div>
    );
};

export default CustomerViewInvoiceHeader;